import React, { useState } from "react";
import { Modal, ModalBody } from "@vds/modals";
import { Micro } from "@vds/typography";
import styled from 'styled-components';
import { stripHTML } from "../../../utils/commonUtils";
import { CloseIcon, InfoCircle } from "../SVGIcons";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import "./PromoBanner.css";

const IconSpan = styled.span`
  margin-left: 0.4375rem;
  position: relative;
  top: 5px;
  `
const ModalWrapper = styled(Modal)`
overflow-y:auto;
`
const PromoBanner = ({ promoData, showClose, bgColor, color }) => {
  const { t } = useTranslation(["app"]);
  const isBannerColorChange =  t("enableBannerColorChange", { ns: "app" });
  const [isVisible, setIsVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const textColor = color || isBannerColorChange =="Y" ? '#000000' : '#ffffff';
  const isMobile = useMediaQuery({
      query: "(max-width: 545px)",
  });

  if (isVisible && promoData?.heading && promoData?.active) {
    return (
      <>
        <div className={`promo-banner ${bgColor && promoData?.tooltipText ? 'cursor-pointer' : ''}`} 
          onClick={() => !!bgColor && promoData?.tooltipText && setShowModal(true)}
          style={{ backgroundColor: bgColor || isBannerColorChange =="Y" ? '#F3EDE0' : '#333333' }}>
          <div className="body-text body-text-promo-banner" >
            <Micro color={textColor}>
              {stripHTML(promoData?.heading)?.replaceAll('&nbsp;', ' ')}
              {promoData?.showTooltip && promoData?.tooltipText && 
               <IconSpan className="cursor-pointer" style={{color: color || isBannerColorChange =="Y" ? '#000000' : '#ffffff'}} onClick={() => setShowModal(true)}> 
                 <InfoCircle height="16" width="16" />
                </IconSpan>} 
            </Micro>
          
          </div>
          {showClose && <CloseIcon onClickFn={() => setIsVisible(false)} />}
        </div>
        {showModal && 
          <DetailsModal
          opened={promoData?.tooltipText && showModal}
          onOpenedChange={setShowModal}
          data-track="Close"
          disableFocusLock={true}>
          <DetailsModalBody>
            {promoData?.tooltipText.includes(".html") ? <iframe
              style={{border:"none", backgroundColor:"white"}}
              height={isMobile?"550px":"674px"}
              width={isMobile?"100%":"560px"}
              src={promoData?.tooltipText}
            ></iframe> : <span dangerouslySetInnerHTML={{__html: promoData?.tooltipText}}/>}
          </DetailsModalBody>
        </DetailsModal>}
      </>
    )
  } else return (<></>);
}

const DetailsModalBody = styled(ModalBody)`
  padding: 0;
  outline: none !important;
  height: 100%;  
`;
const DetailsModal = styled(Modal)`
  overflow-y:auto;
  padding: 1.25rem;
  width: 560px;
  height: 596px;
  min-height: auto;
  outline: none !important;
  [class^=ChildWrapper-VDS]{
    height:98% !important;
  }
  @media only screen and (min-width:768px){
    padding: 4rem 2rem;
    > div:first-child {
      overflow: hidden;
      margin-right:1.5rem;
    }
  } 
  > div:first-child {
    overflow: hidden;
  }
  > div {
    padding:0px !important; 
    
    @media only screen and (max-width:420px) {
      overflow:auto;
      ::-webkit-scrollbar {
        width: 4px;
        height: 20px;
        background: #d8dada;
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #6f7171;
        border-radius: 10px;
      }
    }

    iframe {
      min-height: 250px !important;
      width: 100%;
      border:none !important;
      

      @media only screen and (max-width:420px) {
        overflow:auto;
        ::-webkit-scrollbar {
          width: 4px;
          height: 20px;
          background: #d8dada;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
          background: #6f7171;
          border-radius: 10px;
        }
      }
      
    }

     

    > span {
      height: 100%;
      width:100%;

      & > div {
            height:100% !important;

        & > div {
          padding-right:20px !important;
        }
      }
    }
  }
  @media only screen and (max-width: 767px) {
    position: absolute;
    height: 100vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95vw;
    > div:first-child {
      margin-top: 3rem !important;
    }
    [data-testid="modal-body"]{
      margin-top: 2.5rem !important;
    }
  }

  @media only screen and (max-width:420px) {
    width: 100vw;
  }
`;


export default PromoBanner;